import $ from 'jquery';
import _ from 'underscore';
import Promise from 'bluebird';
import ReactDOM from 'react-dom';
import React from 'react';
import { contents } from '@bingads-webui/popover';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { keyVault } from '@bingads-webui-react/popup-manager';
import { PopupCallout } from './popup-callout';
import reasonTemplate from './reason-template.pug';
import noReasonFoundTemplate from './no-reason-found-template.pug';
import bidlandscapeDisalbedTemplate from './reason-disabled-template.pug';
import template from './template.pug';
import experimentTemplate from './experiment-info.pug';
import editorialCategoryTemplate from './editorial-category-template.pug';
import { CategoryFAID, BLACKLIST, CategoryFALink } from './constants';

function getDateUtils({ i18n }) {
  return {
    reformatDate: (datetime) => {
      const date = datetime && datetime.substr(0, 10).replace(/-/g, '/');
      if (!date) {
        return i18n.getString('None');
      }
      return i18n.formatDate(new Date(datetime), { timeZone: null });
    },
  };
}

export function mapCampaignSpecificDeliveryStatus(
  deliveryStatusUpdated,
  isSmartShoppingCampaignEnabled,
  entity
) {
  let result = deliveryStatusUpdated;
  // special handling logic for smart shopping campaign and performance max campaign
  // as the only bidding strategy option is max conversion value
  // the second bullet-point of the rejection detail text is not needed
  if ((deliveryStatusUpdated === 'AutoBiddingLimitedByNotEnoughRevenue' ||
      deliveryStatusUpdated === 'AutoBiddingLimitedByNotEnoughConversions' ||
      deliveryStatusUpdated === 'NoEligibleAdGroups') &&
        (entity.CampaignType === 'PerformanceMax' ||
        entity.CampaignType === 'LinkedIn' ||
        (isSmartShoppingCampaignEnabled && entity.CampaignSubType === 'ShoppingSmartAds'))) {
    result = `${deliveryStatusUpdated}_For_SSC`;
  } else if (deliveryStatusUpdated === 'UrlInvalid' && entity.CampaignType === 'PerformanceMax') {
    result = `${deliveryStatusUpdated}_For_PMax`;
  }

  return result;
}

export function mapDeliveryStatusForMMC(deliveryStatusUpdated) {
  let result = deliveryStatusUpdated;
  // special handling logic for merchant center related delivery status
  // use go to merchant center link
  if (deliveryStatusUpdated === 'ShoppingCampaignNoOffersPresent') {
    result = `${deliveryStatusUpdated}_With_Link`;
  }

  return result;
}

export function shouldRepairGoogleImportVideoAd(item) {
  return item.Campaign
    && item.Campaign.CampaignSubType === 'BrandAwarenessVideoAds'
    && item.Campaign.CampaignType === 'Audience'
    && item.Campaign.DisplayBiddingStrategyType === 'ManualCpm'
    && _.isArray(item.Videos)
    && item.Videos.length === 1 // Brand Awareness video ad can only have one video
    && _.any(item.Videos, asset => asset.Asset && asset.Asset.SourceType === 'GoogleImported' && asset.Asset.Status === 'Failed');
}

export function getViolationsFromCategoryFAIDMapping(editorialCategories) {
  if (editorialCategories && editorialCategories.length > 0) {
    return _.chain(editorialCategories).map(editorialCategorie => editorialCategorie.Categories)
      .flatten()
      .unique()
      .map(id => CategoryFAID[id])
      .filter(Boolean)
      .unique()
      .map(categoryName => (CategoryFALink[categoryName] &&
        { name: categoryName, link: CategoryFALink[categoryName] }))
      .value()
      .filter(Boolean);
  }
  return [];
}

export function showRejectionReasons({
  deliveryStatusDetails = [],
  actionLinks = [],
  entity,
  event,
  i18n,
  useCustomTemplate = () => false,
  isContextualAttributeForRecommendation = false,
  isInlineDiagnosisForKeyword = false,
  getInlineDiagnosisForKeywordComponent,
  isSmartShoppingCampaignEnabled,
  getCustomTemplate,
  percentSymbol,
  containerSelector = '#rejectionContainer',
  popoverId = 'delivery-status-popup-callout',
  afterRender = () => { },
  view,
  config,
  instrumentation,
  inContextRepairRecommedationType,
  isForAdsPageOnly = false,
  isEditorialCategoryEnabled = false,
}) {
  if ($(containerSelector).length === 0) {
    $(document.body).append(template({}));
  }

  const tableId = `rejection_reason_table_${_.uniqueId()}`;
  const popupContentKey = _.uniqueId(`${keyVault.hoveringPopup}-`);

  // add paged content for EditorialCategory violations
  const violations = getViolationsFromCategoryFAIDMapping(entity ? entity.EditorialCategories : undefined);

  const detailsToShow = _.difference(deliveryStatusDetails, BLACKLIST);

  const reasonCountToShow = Math.min(detailsToShow.length, 3);

  let promises = [];

  const activities = {};
  if (instrumentation) {
    activities.clickActivity =
      instrumentation.inContextRepairRecommendation.create().clickDeliveryStatus.create();
    activities.hoverActivity =
      instrumentation.inContextRepairRecommendation.create().hoverDeliveryStatus.create();
    activities.hoverPopupCalloutDurationActivity =
      instrumentation.popupManagement.create().hoverPopupCalloutDuration.create();
  }

  // get paged content for rejection reason
  if (event.bidlandscapeDisabled) {
    const { DeliveryStatus } = entity;
    promises.push(bidlandscapeDisalbedTemplate({
      deliveryStatus: DeliveryStatus,
      i18n,
    }));
  } else if (isForAdsPageOnly && isEditorialCategoryEnabled && violations.length > 0 && (_.contains(deliveryStatusDetails, 'Eligible') || _.contains(deliveryStatusDetails, 'Approved'))) {
  // for ads grid and Eligible status, only show this data
    promises = [editorialCategoryTemplate({
      violations,
      i18n,
    })];
  } else if (reasonCountToShow > 0) {
    if (isInlineDiagnosisForKeyword) {
      const inActiveReasons = _.result(config.get('CurrentAccount'), 'InactiveReasons') || [];
      const allowedList = [
        'Eligible',
      ];
      promises.push(getInlineDiagnosisForKeywordComponent());
      if (
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (inActiveReasons.length !== 0 && _.contains(allowedList, entity.DeliveryStatus)) ||
        (inActiveReasons.length === 0)
      ) {
        detailsToShow.shift();
      }
    }

    _.map(detailsToShow, (deliveryStatus, index) => {
      if (entity && entity.ExperimentId && entity.AssociatedExperiment) {
        promises.push(experimentTemplate({
          ...entity,
          deliveryStatus,
          i18n,
          percentSymbol,
          expDateUtils: getDateUtils({ i18n }),
          ...({ actionLink: actionLinks[deliveryStatus] }),
        }));
      } else if (useCustomTemplate(deliveryStatus)) {
        promises.push(getCustomTemplate(deliveryStatus, index));
      } else {
        let deliveryStatusUpdated = deliveryStatus;

        // special handling logic for smart shopping campaign
        // as the only bidding strategy option is max conversion value
        // the second bullet-point of the rejection detail text is not needed
        deliveryStatusUpdated = mapCampaignSpecificDeliveryStatus(
          deliveryStatusUpdated,
          isSmartShoppingCampaignEnabled,
          entity
        );

        // special handling logic for merchant center related delivery status
        deliveryStatusUpdated = mapDeliveryStatusForMMC(deliveryStatusUpdated);

        promises.push(reasonTemplate({
          deliveryStatus: deliveryStatusUpdated,
          reasonid: `${tableId}_${index}`,
          ...({ actionLink: actionLinks[deliveryStatus] }),
          i18n,
        }));
      }
    });
  } else if (isContextualAttributeForRecommendation) {
    promises.push(getCustomTemplate());
  } else {
    promises.push(noReasonFoundTemplate({ i18n }));
  }

  // for ads grid Non-Eligible status, append the editorial category page at last
  if (isForAdsPageOnly && isEditorialCategoryEnabled && violations.length > 0 && !_.contains(deliveryStatusDetails, 'Eligible') && !_.contains(deliveryStatusDetails, 'Approved')) {
    promises.push(editorialCategoryTemplate({
      violations,
      i18n,
    }));
  }


  function getLogForInContextRepairRecommedation(deliveryStatus) {
    let mes = {};
    if (inContextRepairRecommedationType === 'ad') {
      const adId = entity ? entity.Id : undefined;
      const adGroupId = entity && entity.AdGroup ? entity.AdGroup.Id : undefined;
      const campaignId = entity && entity.Campaign ? entity.Campaign.Id : undefined;
      mes = {
        CampaignId: campaignId,
        AdGroupId: adGroupId,
        AdId: adId,
        DeliveryStatusType: deliveryStatus,
      };
    } else if (inContextRepairRecommedationType === 'adGroup') {
      const adGroupId = entity ? entity.Id : undefined;
      const campaignId = entity && entity.Campaign ? entity.Campaign.Id : undefined;
      mes = {
        CampaignId: campaignId,
        AdGroupId: adGroupId,
        DeliveryStatusType: deliveryStatus,
      };
    } else if (inContextRepairRecommedationType === 'campaign') {
      const campaignId = entity ? entity.Id : undefined;
      mes = { CampaignId: campaignId, DeliveryStatusType: deliveryStatus };
    }

    return mes;
  }

  function getContentView(pages, page, container) {
    const contentView = new contents.PagedContent({
      pages,
      i18n,
      handlePaginationExternally: true,
    }).setPages(page);
    container.show();

    return contentView;
  }

  function hoverPopupDurationStart() {
    if (window.popupManager) {
      // force acquire lock for user-initiated popup
      window.popupManager.forceAcquireLock(popupContentKey);
    }
    if (activities.hoverPopupCalloutDurationActivity) {
      activities.hoverPopupCalloutDurationActivity.startSignal('onHover');
    }
  }

  function hoverPopupDurationStop() {
    if (window.popupManager) {
      // release lock for user-initiated popup
      window.popupManager.releaseLock(popupContentKey);
    }
    if (activities.hoverPopupCalloutDurationActivity) {
      activities.hoverPopupCalloutDurationActivity.stopSignal('onHoverEnd');
    }
  }

  function renderPages(pages, page, container) {
    const contentView = getContentView(pages, page, container);

    contentView.once('rendered', () => {
      const contentViewReactWrapper = <BackboneInstanceWrapper instance={contentView} />;
      const containerDOM = document.querySelector(containerSelector);

      if (containerDOM) {
        ReactDOM.render(
          <PopupCallout
            content={contentViewReactWrapper}
            target={event.target}
            close={() => {
              ReactDOM.unmountComponentAtNode(containerDOM);
              hoverPopupDurationStop();
            }}
            view={view}
            popoverId={popoverId}
          />,
          containerDOM,
          hoverPopupDurationStart
        );
        afterRender(contentView, event);
      }
    });
    contentView.once('willPageUpdate', (newPage) => {
      view.trigger('closeDeliveryStatusPopup');
      renderPages(pages, newPage, container);
    });

    contentView.$el.one('contentUpdated', (e, newPageContent) => {
      const newPages = [...pages];
      newPages[contentView.currentPage - 1] = newPageContent;
      renderPages(newPages, contentView.currentPage, container);
    });

    // Below code is used to log for measurement
    // Log as click event when user click on the delivery status link
    contentView.$el.on('click', 'a', (eventObject) => {
      if (activities.clickActivity) {
        const deliveryStatus = $(eventObject.target).parent().data('delivery-status');
        if (deliveryStatus) {
          const mes = getLogForInContextRepairRecommedation(deliveryStatus);
          activities.clickActivity.trace(JSON.stringify(mes));
        }
      }
    });

    // Below code is used to log for measurement
    // Log as hover event when user hover no rejection popup and turn to specific page
    // contains delivery status link
    const currentConent = pages[page - 1];

    if (activities.hoverActivity) {
      const deliveryStatus = _.find(
        ['NoEligibleAdGroups', 'NoEligibleAds', 'NoEligibleKeywords', 'ShoppingCampaignNoOffersPresent_With_Link'],
        status => currentConent.includes(status)
      );
      if (deliveryStatus) {
        const mes = getLogForInContextRepairRecommedation(deliveryStatus);
        activities.hoverActivity.trace(JSON.stringify(mes));
      }
    }

    return contentView;
  }

  return new Promise((resolve) => {
    Promise.all(promises).then((pages) => {
      const container = $(containerSelector);
      const contentView = renderPages(pages, 1, container);

      resolve(contentView);
    });
  });
}
